import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './user-group.types';
import * as constants from './user-group.constants';

export const userGroupReducer = generateResourceReducer<types.IUserGroup>({
  STORE: constants.STORE_USER_GROUP,
  CLEAR: constants.CLEAR_USER_GROUP,
});
